import { render } from "./PaymentRedirect.vue?vue&type=template&id=786078dc&ts=true"
import script from "./PaymentRedirect.vue?vue&type=script&lang=ts"
export * from "./PaymentRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__